import { render } from "./map.html?vue&type=template&id=b9fbe55a&scoped=true&ts=true"
import script from "./map.ts?vue&type=script&lang=ts"
export * from "./map.ts?vue&type=script&lang=ts"

import "./map.scss?vue&type=style&index=0&id=b9fbe55a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fbe55a"]])

export default __exports__